import { StyleSheet, ViewProps } from 'react-native'
import { AccessType, Building, useBuildings } from 'zens-store'
import { Color, Spacing } from 'zens-storybook'
import { usePermissions } from '@dms/hook'

import { Grid, GridItemInfo } from '../grid'
import { Panel, PanelSkeletonProps } from '../layout'
import { InsightsBuilding } from '../insights'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  grid: {
    marginTop: -Spacing.M,
    margin: -Spacing.S,
    padding: 0,
    backgroundColor: Color.transparent,
  },
})

interface Props extends ViewProps {
  title?: string
  companyId: number
}

const InsightsGridBuilding = (props: Props) => {
  const { title, companyId, style, ...otherProps } = props
  const buildings = useBuildings({ companyId })
  const { hasPermission } = usePermissions(companyId)
  const canClick = hasPermission(AccessType.Read, 'insights')

  const items =
    buildings.data?.map((building) => ({
      data: building,
      href: canClick ? `/companies/${companyId}/insights/${building.id}` : undefined,
    })) || []

  const renderBuilding = (info: GridItemInfo<Building>) => {
    const { item } = info

    return <InsightsBuilding companyId={companyId} buildingId={item.data.id} />
  }

  return (
    <Panel title={title} style={[styles.container, style]} {...otherProps}>
      <Grid items={items} renderItem={renderBuilding} contentStyle={styles.grid} />
    </Panel>
  )
}

interface SkeletonProps extends PanelSkeletonProps {}
InsightsGridBuilding.Skeleton = (props: SkeletonProps) => (
  <Panel.Skeleton {...props}>
    <Grid.Skeleton contentStyle={styles.grid} itemElement={<InsightsBuilding.Skeleton />} />
  </Panel.Skeleton>
)

export default InsightsGridBuilding
